import React, { useState } from 'react';
import { Card, CardContent, CardMedia, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import './TemplateCard.css';

// 默认占位图 - 使用 SVG Data URI
const DEFAULT_TEMPLATE_ICON = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Crect fill='%23f5f5f5' width='200' height='200'/%3E%3Ctext fill='%23999' font-family='sans-serif' font-size='60' dy='10.5' font-weight='bold' x='50%25' y='50%25' text-anchor='middle'%3E%3Ft%3C/text%3E%3C/svg%3E";

const TemplateCard = ({ template, onClick }) => {
  const { t } = useTranslation('homepage');
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const getImageSrc = () => {
    if (imageError || !template.icon) {
      return DEFAULT_TEMPLATE_ICON;
    }
    return template.icon;
  };

  return (
    <Card 
      className="template-card" 
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: 6
        }
      }}
    >
      <CardMedia
        component="img"
        height="140"
        image={getImageSrc()}
        alt={template.name}
        onError={handleImageError}
        sx={{ 
          objectFit: 'cover',
          backgroundColor: '#f5f5f5'
        }}
      />
      <CardContent>
        <Typography variant="h6" component="div" gutterBottom>
          {template.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {template.description || t('quickStart.clickToViewDetails')}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default TemplateCard;

